<template>
	<div class="main settings-page noscroll">
		<div class="secondary-left-bar">
			<div>
				<h3>Settings</h3>
			</div>
			<div class="layout-column">
				<ul class="secondary-bar-items">
					<li>
						<router-link to="/settings/profile" class="item " >
							<inline-svg :src="require('@/assets/img/account-edit.svg')" />
							<span>Profile</span>
							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />
						</router-link>
					</li>
					<li>
						<router-link to="/settings/account" class="item" :class="{'locked':!isAdmin}">
							<inline-svg :src="require('@/assets/img/products.svg')" />
							<span>Account settings</span>
							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />
						</router-link>
					</li>
					<li>
						<router-link to="/settings/billing" class="item" :class="{'locked':!isAdmin}">
							<inline-svg :src="require('@/assets/img/credit-card-edit.svg')" />
							<span>Billing</span>
							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />
						</router-link>
					</li>
					<li>
						<router-link to="/settings/staff" class="item" :class="{'locked':!isAdmin}">
							<inline-svg :src="require('@/assets/img/users.svg')" />
							<span>Team</span>
							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />
						</router-link>
					</li>
<!--					<li>-->
<!--						<router-link to="/settings/billing" class="item" >-->
<!--							<inline-svg :src="require('@/assets/img/billing_icon.svg')" />-->
<!--							<span>Billing</span>-->
<!--						</router-link>-->
<!--					</li>-->
<!--					<li>-->
<!--						<router-link to="/settings/domains" class="item" >-->
<!--							<inline-svg :src="require('@/assets/img/discounts.svg')" />-->
<!--							<span>Domains</span>-->
<!--						</router-link>-->
<!--					</li>-->
<!--					<li>-->
<!--						<router-link to="/settings/payment-methods" class="item" >-->
<!--							<inline-svg :src="require('@/assets/img/discounts.svg')" />-->
<!--							<span>Payment methods</span>-->
<!--						</router-link>-->
<!--					</li>-->
<!--					<li>-->
<!--						<router-link to="/settings/payment-methods" class="item" >-->
<!--							<inline-svg :src="require('@/assets/img/discounts.svg')" />-->
<!--							<span>API</span>-->
<!--						</router-link>-->
<!--					</li>-->

				</ul>
			</div>
		</div>
		<div class="  noscroll layout-column">
			<div class="main-content noscroll layout-column">
				<div class="flex layout-row noscroll">
					<div class="flex content noscroll">
						<router-view></router-view>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";

export default {
	name: 'Settings',
	title: "Settings | Funnelish™", components: {
		MainSearch
	},
	data() {
		return {}
	},
	computed: {
		isAdmin(){
			try {
				if (!this.$store.state.userInfo.member_account) return false;
				let ma = this.$store.state.userInfo.member_account;
				if (!ma.permissions) return false;
				let p = JSON.parse(ma.permissions);
				return !!p.admin
			} catch {
				return false;
			}
		}
	},
	methods: {
	},
	mounted() {
	},
	beforeMount() {
		if (this.$route.path==='/settings')
			this.$router.replace('/settings/profile')
	}
}
</script>
<style scoped lang="scss">
.settings-page {
	.secondary-left-bar {
		width: 280px;
	}
	.content {
		width: 100%;
		display: flex;
		flex-direction: column;
		height: 100%;
		border: 1px solid $light-grey;
		border-radius: 5px;
	}
	.main-content {
		padding: 40px 40px 40px;
	}
}
</style>
<style lang="scss">
.settings-page {
	.header {
		margin-top: 0;
		border-radius: 5px;
	}
}
</style>
